<template>
    <div class="modal-overlay" @click.self="$store.commit('setVirtualMoney',false)">
        <div class="modal-container">
            <div class="modal-content w-60">
                <div class="modal-header">
                    <h5 class="modal-title" id="otpModalLabel">Reset Virtual Funds?</h5>
                    <button type="button" class="btn-close" @click="$store.commit('setVirtualMoney',false)"  aria-label="Close"></button>
                </div>
                <div class="modal-body ">
                    <form class=""  onsubmit="return false;">
                        <label for="customRange1" class="form-label">Virtual Money : &#8377; {{ parseInt(virtualMoney).toLocaleString('en-IN') }}</label>
                        <input type="range" class="form-range" id="customRange1" min="500000" max="10000000" step="500000" v-model="virtualMoney">
                        <p class="form-label" style="color:green;" >Virtual money isn't just currency; it's the hope of dreams realized.</p>
                        <button  class="btn btn-primary w-100" @click = "createOrder">Reset @  {{ pricePlan.basePrice + ((parseInt(virtualMoney - 500000)/500000)) * pricePlan.incrementPrice  }}  &#8377;</button>
                        <br /> <br />
                            <p class="form-label" style="color:red;" v-if = "errorMsg2!='Password Changed Successfully'">{{ errorMsg2 }}</p>
                            <p class="form-label" style="color:green;" v-if = "errorMsg2 == 'Password Changed Successfully'">{{ errorMsg2 }}</p>
                    </form>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getPricePlan, createOrder, transaction } from '@/service/restService'
export default {
  name: 'SetVirtualMoney',
  components: {
  },
  data () {
    return {
      errorMsg2: '',
      virtualMoney: 500000,
      pricePlan: {},
      isApp: false
    }
  },
  created () {
    getPricePlan('INCREMENT_VIRTUAL').then((response) => {
      this.pricePlan = response.data[0]
    }).catch((error) => {
      this.errorMsg2 = error.response.data.message[0]
    })

    this.isApp = this.isWebView()
  },
  methods: {
    createTransaction: function (amount, orderId) {
      var self = this
      var options = {
        'key': 'rzp_live_MRrPwvjdEfjSMf', // Enter the Key ID generated from the Dashboard
        'amount': amount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        'currency': 'INR',
        'name': 'MegaBull', // your business name
        'description': 'Set Virtuall Money',
        'image': 'https://trade.megabull.in/static/favicon/favicon-76x76.png',
        'order_id': orderId, // This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        'prefill': { // We recommend using the prefill parameter to auto-fill customer's contact information especially their phone number
          'name': this.$store.state.user.firstName, // your customer's name
          'email': this.$store.state.user.emailId,
          'contact': '' // Provide the customer's phone number for better conversion rates
        },
        'theme': {
          'color': '#3399cc'
        },
        'handler': function (response) {
          var data = { orderId: response.razorpay_order_id, paymentId: response.razorpay_payment_id }
          transaction(data).then((response) => {
            self.errorMsg2 = response.data.msg
            self.$router.go(0)
          }).catch((error) => {
            self.errorMsg2 = error.response.data.message[0]
          })
        }
      }
      // console.log(options)
      var rzp1 = new window.Razorpay(options)
      rzp1.open()
      // self.errorMsg2 = 'We\'re excited to announce that this feature will be available shortly. Our team is working hard to bring it to you, and it will be live soon! Stay tuned for updates.'
    },

    createOrder: function () {
      var amount = this.pricePlan.basePrice + ((parseInt(this.virtualMoney - 500000) / 500000)) * this.pricePlan.incrementPrice
      var data = { value: this.virtualMoney, price: amount, type: 'INCREMENT_VIRTUAL' }
      createOrder(data).then((response) => {
        if (!this.isApp) { this.createTransaction(amount, response.data.orderId) } else {
          if (this.getVersion() >= 3) {
            console.log('version ' + this.getVersion())
            var token = localStorage.getItem('token')
            var orderid = response.data.orderId
            var at = amount
            window.location.assign(`${window.location.origin}/processtemplate?token=${token}&orderId=${orderid}&at=${at}`)
          } else { this.errorMsg2 = 'This feature will be available shortly!' }
        }
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    }

  }
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background-color: var(--bs-body-bg);
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  padding: 15px;
}

.modal-content {
  border: none;
  background-color: var(--bs-body-bg);
}
</style>



// WEBPACK FOOTER //
// src/components/profile/SetVirtualMoney.vue